import React from 'react';
import { Button as AntdButton } from 'antd';
import './button.less';

const Button = ({ ...rest }) => {
  return <AntdButton shape="round" {...rest} />;
};
export default Button;
